@let businessProfileForm = businessProfileInput();

<fieldset>
    <div class="form-row row-container d-flex flex-column flex-sm-row">
        <fieldset class="form-group col radio-grid">
            <legend>{{ "business" | translate }}</legend>
            <input
                type="radio"
                [formField]="businessProfileForm.typeOfBusiness"
                value="farmer"
                id="typeOfBusinessFarmer"
            />
            <label for="typeOfBusinessFarmer">{{ "Farmer" | translate }}</label>
            <input
                type="radio"
                [formField]="businessProfileForm.typeOfBusiness"
                value="contractor"
                id="typeOfBusinessContractor"
            />
            <label for="typeOfBusinessContractor">{{
                "Contractor" | translate
            }}</label>
            <input
                type="radio"
                [formField]="businessProfileForm.typeOfBusiness"
                value="machineryRing"
                id="typeOfBusinessMachineryRing"
            />
            <label for="typeOfBusinessMachineryRing">{{
                "MachineryCooperative" | translate
            }}</label>
            <input
                type="radio"
                [formField]="businessProfileForm.typeOfBusiness"
                value="other"
                id="typeOfBusinessOther"
            />
            <label for="typeOfBusinessOther">{{ "Other" | translate }}</label>
        </fieldset>
    </div>
    <div class="form-row row-container d-flex flex-column flex-sm-row">
        <fieldset class="form-group col radio-grid">
            <legend>{{ "FormOfManagement" | translate }}</legend>
            <input
                type="radio"
                [formField]="businessProfileForm.farmingType"
                value="conventional"
                id="farmingTypeConventional"
            />
            <label for="farmingTypeConventional">{{
                "Conventional" | translate
            }}</label>
            <input
                type="radio"
                [formField]="businessProfileForm.farmingType"
                value="organic"
                id="farmingTypeOrganic"
            />
            <label for="farmingTypeOrganic">{{
                "Biological" | translate
            }}</label>
        </fieldset>
    </div>
    <div class="form-row row-container d-flex flex-column flex-sm-row">
        <div class="form-group col">
            <label
                for="businessArea"
                class="form-label"
                [class.required]="businessProfileForm.businessArea().required()"
            >
                {{ "OperatingArea" | translate }}
            </label>
            <input
                type="number"
                class="form-control"
                id="businessArea"
                [formField]="businessProfileForm.businessArea"
            />
        </div>
        <div class="form-group col">
            <label
                for="areaOfArableLand"
                class="form-label"
                [class.required]="
                    businessProfileForm.areaOfArableLand().required()
                "
            >
                {{ "ArableLand" | translate }}
            </label>
            <input
                type="number"
                class="form-control"
                id="areaOfArableLand"
                [formField]="businessProfileForm.areaOfArableLand"
            />
        </div>
    </div>
    <div class="form-row row-container d-flex flex-column flex-sm-row">
        <fieldset class="form-group col" id="companyForm">
            <legend>{{ "CompanyForm" | translate }}</legend>
            <input
                type="checkbox"
                class="checkboxInput"
                id="isdDauerGruen"
                [formField]="businessProfileForm.isdDauerGruen"
            />
            <label
                for="isdDauerGruen"
                class="form-label"
                [class.required]="
                    businessProfileForm.isdDauerGruen().required()
                "
            >
                {{ "PermanentGreenland" | translate }}
            </label>
            <input
                type="checkbox"
                class="checkboxInput"
                id="isAckerbau"
                [formField]="businessProfileForm.isAckerbau"
            />
            <label
                for="isAckerbau"
                class="form-label"
                [class.required]="businessProfileForm.isAckerbau().required()"
            >
                {{ "Agriculture" | translate }}
            </label>
            <input
                type="checkbox"
                class="checkboxInput"
                id="isFutterbau"
                [formField]="businessProfileForm.isFutterbau"
            />
            <label
                for="isFutterbau"
                class="form-label"
                [class.required]="businessProfileForm.isFutterbau().required()"
            >
                {{ "FoodFarm" | translate }}
            </label>
        </fieldset>
    </div>
    <div class="form-row row-container d-flex flex-column flex-sm-row">
        <fieldset class="form-group col" id="livestock">
            <legend>{{ "livestock" | translate }}</legend>
            <input
                type="checkbox"
                class="checkboxInput"
                id="hasDairyCows"
                [formField]="businessProfileForm.hasDairyCows"
            />
            <label
                for="hasDairyCows"
                class="form-label checkbox-label"
                [class.required]="businessProfileForm.hasDairyCows().required()"
            >
                {{ "dairyCows" | translate }}
            </label>
            <input
                type="number"
                class="form-control input-count"
                id="countOfDairyCows"
                [formField]="businessProfileForm.countOfDairyCows"
                placeholder="{{ 'numberOf' | translate }} {{
                    'dairyCows' | translate
                }}"
            />
            <input
                type="checkbox"
                class="checkboxInput"
                id="hasCattle"
                [formField]="businessProfileForm.hasBeef"
            />
            <label
                for="hasCattle"
                class="form-label checkbox-label"
                [class.required]="businessProfileForm.hasBeef().required()"
            >
                {{ "beefFarm" | translate }}
            </label>
            <input
                type="number"
                class="form-control input-count"
                id="countOfCattle"
                [formField]="businessProfileForm.countOfBeef"
                placeholder="{{ 'numberOf' | translate }} {{
                    'cattle' | translate
                }}"
            />
            <input
                type="checkbox"
                class="checkboxInput"
                id="hasPigs"
                [formField]="businessProfileForm.hasPig"
            />
            <label
                for="hasPigs"
                class="form-label checkbox-label"
                [class.required]="businessProfileForm.hasPig().required()"
            >
                {{ "pigFattening" | translate }}
            </label>
            <input
                type="number"
                class="form-control input-count"
                id="countOfPigs"
                [formField]="businessProfileForm.countOfPig"
                placeholder="{{ 'numberOf' | translate }} {{
                    'pigs' | translate
                }}"
            />
            <input
                type="checkbox"
                class="checkboxInput"
                id="hasFowl"
                [formField]="businessProfileForm.hasFowl"
            />
            <label
                for="hasFowl"
                class="form-label checkbox-label"
                [class.required]="businessProfileForm.hasFowl().required()"
            >
                {{ "fowlFattening" | translate }}
            </label>
            <input
                type="number"
                class="form-control input-count"
                id="countOfFowl"
                [formField]="businessProfileForm.countOfFowl"
                placeholder="{{ 'numberOf' | translate }} {{
                    'fowl' | translate
                }}"
            />
            <input
                type="checkbox"
                class="checkboxInput"
                id="hasOtherAnimals"
                [formField]="businessProfileForm.hasOtherAnimals"
            />
            <label
                for="hasOtherAnimals"
                class="form-label checkbox-label"
                [class.required]="
                    businessProfileForm.hasOtherAnimals().required()
                "
            >
                {{ "otherFarmAnimals" | translate }}
            </label>
            <input
                type="number"
                class="form-control input-count"
                id="countOfOtherAnimals"
                [formField]="businessProfileForm.countOfOtherAnimals"
                placeholder="{{ 'countOf' | translate }}"
            />
        </fieldset>
    </div>
</fieldset>
